/** Irelia canvas painter stub. */
export class IreliaPainter {
  static draw(ctx, entity, teamColor) {
    ctx.fillStyle = teamColor || '#f472b6';
    ctx.beginPath();
    ctx.arc(entity.x, entity.y, entity.radius || 20, 0, Math.PI * 2);
    ctx.fill();
  }
}
